/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, street, exterior_number, interior_number, suburb, postal_code, city, state },
} = checkout;

const validations = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg),
  [street.name]: Yup.string().required(street.errorMsg),
  [exterior_number.name]: Yup.string().required(exterior_number.errorMsg),
  [suburb.name]: Yup.string().required(suburb.errorMsg),
  [postal_code.name]: Yup.string().required(postal_code.errorMsg),
  [city.name]: Yup.string().required(city.errorMsg),
  [state.name]: Yup.string().required(state.errorMsg),
});

export default validations;
